import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectAutomatticTemplatesCount = createSelector(
  [(store: RootState) => store.userTemplate.automatticTemplates],
  (data) => data.length
);
